export const docUrls = {
  'AT ELD': [
    {
      docName: 'AT_ELD_DOT_Card_and_Instructions_1_compressed.pdf',
      url: 'http://d3abosbt379lyb.cloudfront.net/AT_ELD_DOT_Card_and_Instructions_1_compressed.pdf',
    },
    {
      docName: 'AT_ELD_User_manual_Mobile+App_compressed.pdf',
      url: 'http://d3abosbt379lyb.cloudfront.net/AT_ELD_User_manual_Mobile+App_compressed.pdf',
    },
    {
      docName: 'Signed+certificate.pdf',
      url: 'http://d3abosbt379lyb.cloudfront.net/Signed+certificate.pdf',
    },
  ],
  'MGK ELD': [
    {
      docName: 'Certificate_of_ELD_Provider.pdf',
      url: 'http://d2665hv1tea275.cloudfront.net/Certificate_of_ELD_Provider.pdf',
    },
    {
      docName: 'Inspection.pdf',
      url: 'http://d2665hv1tea275.cloudfront.net/Inspection.pdf',
    },
    {
      docName: 'User_Manual.pdf',
      url: 'http://d2665hv1tea275.cloudfront.net/User_Manual.pdf',
    },
  ],
  'NOOR ELD': [
    {
      docName: 'Noor_Certificate.jpg',
      url: 'http://d1r08jvhekeyxk.cloudfront.net/Noor_Certificate.jpg',
    },
    {
      docName: 'NOOR_ELD_DOT_Card_and_Instructions-1.pdf',
      url: 'http://d1r08jvhekeyxk.cloudfront.net/NOOR_ELD_DOT_Card_and_Instructions-1.pdf',
    },
    {
      docName: 'Noor_User+manual+file+for+Mobile+App-1.pdf',
      url: 'http://d1r08jvhekeyxk.cloudfront.net/Noor_User+manual+file+for+Mobile+App-1.pdf',
    },
  ],
  'ORIENT ELD': [
    {
      docName: 'Orient+eld+certificate.pdf',
      url: 'http://d17bzhxf6y4the.cloudfront.net/Orient+eld+certificate.pdf',
    },
    {
      docName: 'Orient+ELD+User+manual.pdf',
      url: 'http://d17bzhxf6y4the.cloudfront.net/Orient+ELD+User+manual.pdf',
    },
    {
      docName: 'Orient_ELD_DOT_Card_and_Instructions.pdf',
      url: 'http://d17bzhxf6y4the.cloudfront.net/Orient_ELD_DOT_Card_and_Instructions.pdf',
    },
  ],
  'RELIABLE ELD': [
    {
      docName: 'Reliable+certificate.pdf',
      url: 'http://djw0h1i7rb09s.cloudfront.net/Reliable+certificate.pdf',
    },
    {
      docName: 'RELIABLE+ELD+inspection.pdf',
      url: 'http://djw0h1i7rb09s.cloudfront.net/RELIABLE+ELD+inspection.pdf',
    },
    {
      docName: 'RELIABLE+ELD+MANUAL-1.pdf',
      url: 'http://djw0h1i7rb09s.cloudfront.net/RELIABLE+ELD+MANUAL-1.pdf',
    },
  ],
};
